import React, { Component } from "react";
import { connect } from "react-redux";
import {
  postJob,
  testsMetadataStandards,
  fiberTestsMetadataStandards,
  metadataStandardsCustom,
  testsSave,
  testsFiberSave,
  testsReset,
  testsList,
  testsSelected,
  testsMove,
  testsDelete,
  getTest,
  getFiberTest,
  testUpdate,
  fiberTestUpdate,
  testRecert,
  savePreferences,
  selectColumnPreset,
  updateColumnPreset,
  generateReport,
  getCustomer,
  customerList,
  activateSuspiciousFilter,
  getAttachments,
  uploadAttachment,
  deleteAttachment,
  attachmentDownload,
  getJobs,
  resetJobCreateForm,
  jobTestsReset,
  checkReportCanBeGenerated,
  checkReportCanBeGeneratedForTreeview,
  hideResults,
  hideResultHeader,
  clearAttachments,
  clearErrors,
  jobUpdateAndList,
  signaltek10gTestList,
  saveSignaltekNewTests,
  getSignatek10gTest,
  updateSignaltekTests,
  signalTekTestsMove,
  signaltekTestsDelete,
  saveSelectedRow,
  getUserPreference,
  postUserPreference,
  signaltekSubTestsDelete,
  uploadTestIDFile,
  clearImportErrors,
  countryStateList,
  jobModified
} from "../../redux/actions";

import { getActiveLanguage } from "react-localize-redux";

import Job from "../../components/job";
import {
  getPresetDefaultColumns,
  preparePager,
  prepareSearch
} from "../../common/tabletools";
import job from "../../components/job";
import SignalTek10GJob from "../../components/job/signaltek10g";
import { isSignalTEK10GType } from '../../common/utils';

class JobPage extends Component {
  constructor(props) {
    super(props);
    const { preferences, profile } = this.props;

    // Load all columns in advance - preset is being applied later
    let defaultColumns = getPresetDefaultColumns();

    let pager =
      preferences && preferences.pager
        ? preferences.pager
        : {
            defaultColumns: defaultColumns,
            manual: true,
            pageno: 1,
            pagesize: 10,
            order: {},
            search: []
          };
    pager.unit = profile && profile.units ? profile.units : "meters";
    // pager.pagesize = this.isSignalTek10g() ? 10 : 5;
    // pager.pageSize = this.isSignalTek10g() ? 10 : 5;

    pager.defaultColumns = defaultColumns;
    this.state = {
      nameList: {},
      pager
      // userPreference: {
      //   ping4: true,
      //   ping6: false,
      //   traceroute4: true,
      //   traceroute6: false,
      //   netscan: true,
      //   maxthroughput: true,
      //   uptime: true,
      //   customdata: true,
      //   cabledata: true,
      //   webdata: true,
      //   voipdata: true,
      //   videodata: true,
      //   cctvdata: true,
      //   wiremap: true,
      //   poeload: true,
      //   metaDatalookupid: null,
      //   metadata: [
      //     {
      //       level: "1",
      //       field: null,
      //       value: ""
      //     },
      //     {
      //       level: "2",
      //       field: null,
      //       value: ""
      //     },
      //     {
      //       level: "3",
      //       field: null,
      //       value: ""
      //     },
      //     {
      //       level: "4",
      //       field: null,
      //       value: ""
      //     },
      //     {
      //       level: "5",
      //       field: null,
      //       value: ""
      //     },
      //     {
      //       level: "6",
      //       field: null,
      //       value: ""
      //     }
      //   ]
      // }
    };
    this.fetch = this.fetch.bind(this);
    this.search = this.search.bind(this);
    this.copperModalState = null;
    this.fiberModalState = null;
    this.signaltekModalState = null;
    this.saveTests = this.saveTests.bind(this);
    this.saveFiberNewTests = this.saveFiberNewTests.bind(this);
    this.saveSignaltekNewTests = this.saveSignaltekNewTests.bind(this);
    this.uploadTestIDFile = this.uploadTestIDFile.bind(this);
  }

  fetch(table, pager) {
    const preparedPager = preparePager(table, pager);

    if (!this.isSignalTek10g()) {
      this.props.getTests(
        preparedPager,
        this.props.match.params.id
      );
    } else {
      this.props.signaltek10gTestList(
        preparedPager,
        this.props.match.params.id
      );
    }
  }

  search(term) {
    const { lists } = this.props;
    const { columns } = lists;
    const { pager } = this.state;
    const _pager = prepareSearch(term, columns, pager);
    _pager.global = term === "" ? false : true;
    this.setState({
      pager: _pager
    });
    if (!this.isSignalTek10g()) {
      this.props.getTests(prepareSearch(_pager), this.props.match.params.id);
    } else {
      this.props.signaltek10gTestList(
        prepareSearch(_pager),
        this.props.match.params.id
      );
    }
  }

  saveTests(job, pager) {
    this.copperModalState = job;
    this.props.saveNewTests(job, pager);
  }
  saveFiberNewTests(job, pager) {
    this.fiberModalState = job;
    this.props.saveFiberNewTests(job, pager);
  }
  saveSignaltekNewTests(job, pager) {
    //this.signaltekModalState = job;

    this.props.saveSignaltekNewTests(job, pager);
  }

  componentWillMount() {
    let isSignalTek10g = false;
    const { preferences, savePreferences } = this.props;
    const { jobid, tests, jobs, testListOf10g } = this.props;
    const currentJobId = this.props.match.params.id;
    
    isSignalTek10g = this.isSignalTek10g();

    if (currentJobId != jobid) {
      this.props.resetForm();
      this.props.resetTests();
      this.props.resetJobCreateForm();
      this.props.hideResults();
      this.props.hideResultHeader();
    }

    if (preferences && preferences.pager && currentJobId != jobid) {
      preferences.pager.pageIndex = 0;
      preferences.pager.search = [];
      preferences.pager.filter = [];
      savePreferences(
        preferences.pager,
        preferences.columns ? preferences.columns : null,
        true
      );

      if (!isSignalTek10g) {
        this.props.getTests(this.state.pager, currentJobId);
      }
      if (!testListOf10g && isSignalTek10g) {
        this.props.signaltek10gTestList(this.state.pager, currentJobId);
      }
    } else {
      if (!isSignalTek10g) {
        this.props.getTests(this.state.pager, currentJobId);
      } else {
        this.props.signaltek10gTestList(this.state.pager, currentJobId);
      }
    }
    this.props.start(currentJobId);
    this.props.getCountryStateList(this.props.activeLanguage);
  }

  refresh = () => {
    const { pager } = this.state;
    const { job } = this.props;
    const currentJobId = this.props.match.params.id;
    this.props.start(currentJobId);
    if (!this.isSignalTek10g()) {
      this.props.getTests(pager, job.id);
    } else {
      this.props.signaltek10gTestList(pager, job.id);
    }
  };

  isSignalTek10g = () => {
    let isSignalTek10g = false;
    const { job, jobs, testListOf10g } = this.props;

    if (job) {
      isSignalTek10g = isSignalTEK10GType(job.deviceid);
    }

    const currentJobId = this.props.match.params.id;
    if (jobs && jobs.data && jobs.data.length) {
      let selectedJob = jobs.data.filter(j => j.id == currentJobId);
      if (selectedJob && selectedJob.length) {
        isSignalTek10g = isSignalTEK10GType(selectedJob[0].deviceid);
      }
    }
    return isSignalTek10g;
  };

  componentDidUpdate() {
    const { tests } = this.props;
    if (tests && tests.errors && tests.errors === "error_no_permission") {
      this.props.history.push("/jobs");
    }
  }

  uploadTestIDFile(data) {
    this.props.uploadTestIDFile(data);
    this.setState({
      nameList: {
        success: true,
        errors: "Invalid_Character",
        names: ["Port001", "Port002", "Port003", "Port005"]
      }
    });
  }

  render() {
    const {
      translate,
      job,
      jobs,
      standards,
      fiberStandards,
      getStandards,
      getFiberStandards,
      getCustom,
      custom,
      languages,
      testsCreated,
      errors,
      resetForm,
      tests,
      setSelectedTests,
      moveTests,
      deleteTests,
      getTest,
      getFiberTest,
      test,
      fibertest,
      saveEditTest,
      saveFiberEditTest,
      saveRecertTest,
      profile,
      impersonating,
      savePreferences,
      selectColumnPreset,
      updateColumnPreset,
      columnPreset,
      columnPresets,
      preferences,
      preferencesSaved,
      getCustomers,
      getCustomer,
      customers,
      customer,
      generateReport,
      activateSuspiciousFilter,
      attachments,
      getAttachments,
      uploadAttachment,
      deleteAttachment,
      attachmentDownload,
      getTests,
      filteredJobs,
      getJobs,
      checkForReport,
      checkForReportForTreeview,
      selectedCustomerId,
      selectedCustomerName,
      clearAttachments,
      clearDuplicateError,
      lantekreportcount,
      cometreportcount,
      selectedLanguage,
      testListOf10g,
      signaltek10gTestList,
      getSignatek10gTest,
      signaltekTest,
      updateSignaltekTests,
      signalTekTestsMove,
      signaltekTestsDelete,
      saveSelectedRow,
      previousRow,
      testNames,
      userPreference,
      getUserPreference,
      postUserPreference,
      signaltekSubTestsDelete,
      testNameList,
      IDerrors,
      clearImportDuplicateError,
      countryStates,
      modifiedJobId
    } = this.props;
    const { pager } = this.state;
    if (tests && tests.errors && tests.errors === "error_no_permission") {
      return null;
    }

    if (modifiedJobId > 0) {
      if (job && (this.props.match.params.id == modifiedJobId)) {
        this.refresh();
      }
      this.props.resetModifiedJobId();
    }

    if (job && !this.isSignalTek10g()) {
      return (
        <Job
          job={job}
          jobs={jobs}
          translate={translate}
          standards={standards}
          fiberStandards={fiberStandards}
          languages={languages}
          getStandards={getStandards}
          getFiberStandards={getFiberStandards}
          custom={custom}
          getCustom={getCustom}
          saveNewTests={this.saveTests}
          saveFiberNewTests={this.saveFiberNewTests}
          saveEditTest={saveEditTest}
          saveFiberEditTest={saveFiberEditTest}
          saveRecertTest={saveRecertTest}
          testsCreated={testsCreated}
          errors={errors}
          resetForm={resetForm}
          tests={tests}
          pager={pager}
          fetch={this.fetch}
          search={this.search}
          copperModalState={this.copperModalState}
          fiberModalState={this.fiberModalState}
          setSelectedTests={setSelectedTests}
          moveTests={moveTests}
          deleteTests={deleteTests}
          getTest={getTest}
          getFiberTest={getFiberTest}
          test={test}
          fibertest={fibertest}
          profile={profile}
          impersonating={impersonating}
          savePreferences={savePreferences}
          selectColumnPreset={selectColumnPreset}
          updateColumnPreset={updateColumnPreset}
          columnPreset={columnPreset}
          columnPresets={columnPresets}
          preferences={preferences}
          preferencesSaved={preferencesSaved}
          getCustomers={getCustomers}
          getCustomer={getCustomer}
          customers={customers}
          customer={customer}
          generateReport={generateReport}
          activateSuspiciousFilter={activateSuspiciousFilter}
          getAttachments={getAttachments}
          attachments={attachments}
          uploadAttachment={uploadAttachment}
          deleteAttachment={deleteAttachment}
          attachmentDownload={attachmentDownload}
          getTests={getTests}
          filteredJobs={filteredJobs}
          getJobs={getJobs}
          refresh={this.refresh}
          checkForReport={checkForReport}
          checkForReportForTreeview={checkForReportForTreeview}
          selectedCustomerId={selectedCustomerId}
          selectedCustomerName={selectedCustomerName}
          clearAttachments={clearAttachments}
          clearDuplicateError={clearDuplicateError}
          lantekreportcount={lantekreportcount}
          cometreportcount={cometreportcount}
          selectedLanguage={selectedLanguage}
          signaltek10gTestList={signaltek10gTestList}
          saveSelectedRow={saveSelectedRow}
          previousRow={previousRow}
          testNames={testNames}
          getUserPreference={getUserPreference}
          userPreference={userPreference}
          postUserPreference={postUserPreference}
          uploadTestIDFile={this.uploadTestIDFile}
          testNameList={testNameList}
          IDerrors={IDerrors == null ? {} : IDerrors}
          clearImportDuplicateError={clearImportDuplicateError}
          countryStates={countryStates}
        />
      );
    } else if (job && this.isSignalTek10g()) {
      return (
        <SignalTek10GJob
          job={job}
          jobs={jobs}
          translate={translate}
          standards={standards}
          fiberStandards={fiberStandards}
          languages={languages}
          getStandards={getStandards}
          getFiberStandards={getFiberStandards}
          custom={custom}
          getCustom={getCustom}
          saveNewTests={this.saveTests}
          saveFiberNewTests={this.saveFiberNewTests}
          saveEditTest={saveEditTest}
          saveFiberEditTest={saveFiberEditTest}
          saveRecertTest={saveRecertTest}
          testsCreated={testsCreated}
          errors={errors}
          resetForm={resetForm}
          tests={testListOf10g}
          pager={pager}
          fetch={this.fetch}
          search={this.search}
          copperModalState={this.copperModalState}
          fiberModalState={this.fiberModalState}
          setSelectedTests={setSelectedTests}
          moveTests={signalTekTestsMove}
          deleteTests={signaltekTestsDelete}
          getTest={getSignatek10gTest}
          getFiberTest={getFiberTest}
          test={signaltekTest}
          fibertest={fibertest}
          profile={profile}
          savePreferences={savePreferences}
          selectColumnPreset={selectColumnPreset}
          updateColumnPreset={updateColumnPreset}
          columnPreset={columnPreset}
          columnPresets={columnPresets}
          preferences={preferences}
          preferencesSaved={preferencesSaved}
          getCustomers={getCustomers}
          getCustomer={getCustomer}
          customers={customers}
          customer={customer}
          generateReport={generateReport}
          activateSuspiciousFilter={activateSuspiciousFilter}
          getAttachments={getAttachments}
          attachments={attachments}
          uploadAttachment={uploadAttachment}
          deleteAttachment={deleteAttachment}
          attachmentDownload={attachmentDownload}
          getTests={signaltek10gTestList}
          filteredJobs={filteredJobs}
          getJobs={getJobs}
          refresh={this.refresh}
          checkForReport={checkForReport}
          checkForReportForTreeview={checkForReportForTreeview}
          selectedCustomerId={selectedCustomerId}
          selectedCustomerName={selectedCustomerName}
          clearAttachments={clearAttachments}
          clearDuplicateError={clearDuplicateError}
          lantekreportcount={lantekreportcount}
          cometreportcount={cometreportcount}
          selectedLanguage={selectedLanguage}
          signaltek10gTestList={signaltek10gTestList}
          saveSignaltekNewTests={this.saveSignaltekNewTests}
          signaltekModalState={this.signaltekModalState}
          updateSignaltekTests={updateSignaltekTests}
          saveSelectedRow={saveSelectedRow}
          previousRow={previousRow}
          testNames={testNames}
          getUserPreference={getUserPreference}
          userPreference={userPreference}
          postUserPreference={postUserPreference}
          deleteSubTests={signaltekSubTestsDelete}
          uploadTestIDFile={this.uploadTestIDFile}
          testNameList={testNameList}
          IDerrors={IDerrors == null ? {} : IDerrors}
          clearImportDuplicateError={clearImportDuplicateError}
          countryStates={countryStates}
        />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({
  job: state.jobReducer.job,
  jobs: state.jobReducer.jobs,
  tests: state.testsReducer.tests,
  standards: state.testsReducer.standards,
  fiberStandards: state.testsReducer.fiberStandards,
  testsCreated: state.testsReducer.testsCreated,
  errors: state.testsReducer.errors,
  custom: state.jobReducer.custom,
  languages: state.localeReducer.languages,
  test: state.testsReducer.test,
  fibertest: state.testsReducer.fibertest,
  profile: state.userReducer.user,
  impersonating: state.userReducer.impersonating,
  preferencesSaved: state.testsReducer.preferencesSaved,
  preferences: state.testsReducer.preferences,
  columnPreset: state.testsReducer.columnPreset,
  columnPresets: state.testsReducer.columnPresets,
  jobid: state.testsReducer.jobid,
  customers: state.customerReducer.customers,
  customer: state.customerReducer.customer,
  attachments: state.testsReducer.attachments,
  filteredJobs: state.jobReducer.filteredJobs,
  selectedCustomerId: state.jobReducer.selectedCustomerId,
  selectedCustomerName: state.jobReducer.selectedCustomerName,
  lantekreportcount: state.authReducer.lantekreportcount,
  cometreportcount: state.authReducer.cometreportcount,
  selectedLanguage: state.languageReducer.selectedLanguage,
  testListOf10g: state.testsReducer.testListOf10g,
  signaltekTest: state.testsReducer.signaltekTest,
  previousRow: state.jobReducer.previousRow,
  testNames: state.testsReducer.testNames,
  userPreference: state.testsReducer.userPreference,
  testNameList: state.jobReducer.testNameList,
  IDerrors: state.jobReducer.IDerrors,
  countryStates: state.customerReducer.countryStates,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  modifiedJobId: state.jobReducer.modifiedJobId,

  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  start: id => {
    dispatch(postJob(id));
  },
  getTests: (pager, id) => {
    dispatch(testsList(pager, id));
  },
  getStandards: () => {
    return dispatch(testsMetadataStandards());
  },
  getFiberStandards: () => {
    return dispatch(fiberTestsMetadataStandards());
  },
  getCustom: () => {
    dispatch(metadataStandardsCustom());
  },
  saveNewTests: (tests, pager) => {
    dispatch(testsSave(tests, pager));
  },
  saveFiberNewTests: (tests, pager) => {
    dispatch(testsFiberSave(tests, pager));
  },
  resetForm: () => {
    dispatch(testsReset());
  },
  resetTests: () => {
    dispatch(jobTestsReset());
  },
  setSelectedTests: tests => {
    dispatch(testsSelected(tests));
  },
  moveTests: (data, pager) => {
    return dispatch(testsMove(data, pager));
  },
  deleteTests: (data, pager) => {
    return dispatch(testsDelete(data, pager));
  },
  getTest: testid => {
    dispatch(getTest(testid));
  },
  getFiberTest: testid => {
    dispatch(getFiberTest(testid));
  },
  saveEditTest: (test, pager) => {
    return dispatch(testUpdate(test, pager));
  },
  saveFiberEditTest: (test, pager) => {
    return dispatch(fiberTestUpdate(test, pager));
  },
  saveRecertTest: (test, pager) => {
    return dispatch(testRecert(test, pager));
  },
  savePreferences: (pager, columns, preferencesSaved, updatePreset = false) => {
    dispatch(savePreferences(pager, columns, preferencesSaved, updatePreset));
  },
  selectColumnPreset: (preset) => {
    dispatch(selectColumnPreset(preset));
  },
  updateColumnPreset: (preset, columns) => {
    dispatch(updateColumnPreset(preset, columns))
  },
  getCustomers: pager => {
    dispatch(customerList(pager));
  },
  getCustomer: cid => {
    dispatch(getCustomer(cid));
  },
  generateReport: data => {
    dispatch(generateReport(data));
  },
  activateSuspiciousFilter: (jobId, pager) => {
    dispatch(activateSuspiciousFilter(jobId, pager));
  },
  getAttachments: (jobid, testid) => {
    dispatch(getAttachments(jobid, testid));
  },
  uploadAttachment: (file, jobid, testid) => {
    dispatch(uploadAttachment(file, jobid, testid));
  },
  deleteAttachment: file => {
    dispatch(deleteAttachment(file));
  },
  attachmentDownload: file => {
    dispatch(attachmentDownload(file));
  },
  getJobs: deviceid => {
    return dispatch(getJobs(deviceid));
  },
  resetJobCreateForm: () => {
    return dispatch(resetJobCreateForm());
  },
  checkForReport: ({ testids, selectall, jobid }) => {
    return dispatch(checkReportCanBeGenerated({ testids, selectall, jobid }));
  },
  checkForReportForTreeview: ({ nodeId, jobId, includeChildren }) => {
    return dispatch(checkReportCanBeGeneratedForTreeview({ nodeId, jobId, includeChildren }));
  },
  hideResults: () => {
    dispatch(hideResults());
  },
  hideResultHeader: () => {
    dispatch(hideResultHeader());
  },
  clearAttachments: () => {
    dispatch(clearAttachments());
  },
  clearDuplicateError: () => {
    dispatch(clearErrors());
  },
  signaltek10gTestList: (pager, id) => {
    dispatch(signaltek10gTestList(pager, id));
  },
  saveSignaltekNewTests: (tests, pager) => {
    dispatch(saveSignaltekNewTests(tests, pager));
  },
  getSignatek10gTest: testid => {
    dispatch(getSignatek10gTest(testid));
  },
  updateSignaltekTests: (test, pager) => {
    return dispatch(updateSignaltekTests(test, pager));
  },
  signalTekTestsMove: (data, pager) => {
    return dispatch(signalTekTestsMove(data, pager));
  },
  signaltekTestsDelete: (data, pager) => {
    return dispatch(signaltekTestsDelete(data, pager));
  },
  saveSelectedRow: currentRow => {
    dispatch(saveSelectedRow(currentRow));
  },
  getUserPreference: () => {
    dispatch(getUserPreference());
  },
  postUserPreference: (issignaltek, preferenceModel) => {
    dispatch(postUserPreference(issignaltek, preferenceModel));
  },
  signaltekSubTestsDelete: (data, pager) => {
    return dispatch(signaltekSubTestsDelete(data, pager));
  },
  uploadTestIDFile: data => {
    dispatch(uploadTestIDFile(data));
  },
  clearImportDuplicateError: () => {
    dispatch(clearImportErrors());
  },
  getCountryStateList: languageCode => {
    dispatch(countryStateList(languageCode));
  },
  resetModifiedJobId: () => {
    dispatch(jobModified(-1));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobPage);



// WEBPACK FOOTER //
// ./src/pages/job/index.js